import Link from 'next/link'

import AndroidHandler from 'utils/androidHandler'

import type { LinkProps } from 'next/link'
import type { AnchorHTMLAttributes, ReactNode } from 'react'

type NextNavigationProps = Pick<
  LinkProps,
  'locale' | 'prefetch' | 'replace' | 'scroll' | 'shallow'
>

export type TAnchorProps = Omit<
  AnchorHTMLAttributes<HTMLAnchorElement>,
  'href'
> & {
  href: string
  children: ReactNode
} & NextNavigationProps

export const Anchor = (props: TAnchorProps) => {
  const {
    href,
    children,
    locale,
    prefetch,
    replace,
    scroll,
    shallow,
    ...anchorProps
  } = props
  const androidHandler = AndroidHandler()
  const isAndroid = androidHandler.enabled

  if (isAndroid) {
    return (
      <a href={href} {...anchorProps}>
        {children}
      </a>
    )
  }

  return (
    <Link
      href={href}
      locale={locale}
      prefetch={prefetch}
      replace={replace}
      scroll={scroll}
      shallow={shallow}
      {...anchorProps}
    >
      {children}
    </Link>
  )
}
